var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "ugcentrypoint-chooseimage"
  }, [_c('div', {
    staticClass: "ugcentrypoint-chooseimage-input-wrapper"
  }, [_c('input', {
    ref: _vm.inputId,
    staticClass: "hide ugc-image-source",
    attrs: {
      "id": _vm.inputId,
      "type": "file",
      "accept": "image/jpg,image/jpeg,image/png",
      "name": _vm.inputId
    },
    on: {
      "change": _vm.setUGCImage
    }
  }), _c('div', {
    staticClass: "ugcentrypoint-button-ugc-upload-wrapper"
  }, [_c('button', {
    staticClass: "ugc-uploader-label button ugcentrypoint-button",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.onUploadClick
    }
  }, [_c('span', {
    staticClass: "icon icon-camera"
  }), _vm._v(" \n        " + _vm._s(_vm.translations[_vm.inputLabel || 'ugcEPChooseImage']) + "\n      ")])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }